//菜单：签核职务页面
import React from 'react'
import Manager from '../../public/components/Manager'
import SignOffPosition from './SignOffPosition'
Ext.require('Ext.Toast')

const config = {
    buttons: [
    ],
    columns: [
        { _text: '签核名称', minWidth: 150, flex: 1 },
        { _text: '签核金额', field: '_Amount', minWidth: 150, },
        { _text: '职务名称', minWidth: 150, flex: 1 },
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        Tyan.pubForm.showDialog('签核职务', props => <SignOffPosition {...props} id={data.id} onSave={refreshPage} />)
    }
}

export default props => <Manager {...props} config={config} />